export const headerStyles: Record<string, React.CSSProperties> = {
  dividerMargin: {
    marginBottom: 15,
  },
  headerDivider: { margin: 5, borderBlockColor: 'red', color: 'red' },
};
